module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_8019.a07ed759.png";